import React from "react";
import styles from "./ProfileHeader.module.scss";
import { useAppSelector } from "../../../utils/store";
import { AccountType } from "../../../core/auth/auth.entity";
import { CloseIcon } from "@bale/ui";
import classNames from "classnames";
import { isISOTimeAfterToday } from "utils/time";

type Props = {
  closeSidebar?: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileHeader = (props: Props) => {
  const myPanel = useAppSelector((state) => state.auth.myPanel);
  const packageHasTime = isISOTimeAfterToday(myPanel.credit_expire_time);

  return (
    <div className={styles.Container}>
      <div
        className={classNames(styles.ProfileBg, {
          [styles.VIPProfileBg]: packageHasTime,
        })}
      >
        {packageHasTime ? (
          <img src={"/icons/vipAccountProfile.svg"} alt="vip" />
        ) : (
          <img src={"/icons/profile.svg"} alt="profile" />
        )}
      </div>
      <div className={styles.InfoWrapper}>
        <p className={styles.OwnerName}>{myPanel?.owner_name}</p>
        {myPanel?.type === AccountType.Organization && (
          <p className={styles.OrganizationName}>{myPanel?.name}</p>
        )}
      </div>
      <CloseIcon
        size={24}
        className={styles.CloseIcon}
        onClick={() => props.closeSidebar?.(false)}
      />
    </div>
  );
};

export default ProfileHeader;
